document.addEventListener('DOMContentLoaded', function() {
  function updateAllVariantMetafields(variantId) {
    const allMetafieldBlocks = document.querySelectorAll('.variant-metafield-block');
    
    allMetafieldBlocks.forEach(block => {
      const allVariantInfo = block.querySelectorAll('.variant-info');
      allVariantInfo.forEach(el => {
        // Nur verstecken wenn es ein Multi-Variant Produkt ist UND data-variant-id hat
        if (el.hasAttribute('data-variant-id')) {
          el.style.display = 'none';
        }
      });
      
      const currentVariantInfo = block.querySelector(`.variant-info[data-variant-id="${variantId}"]`);
      if (currentVariantInfo) {
        currentVariantInfo.style.display = 'flex';
      }
    });
  }
  
  // Prüfen ob es ein Multi-Variant Produkt ist
  const variantSelects = document.querySelectorAll('select[name="id"], input[name="id"]');
  if (variantSelects.length > 0) {
    // Multi-Variant Produkt
    document.addEventListener('variant:change', function(event) {
      updateAllVariantMetafields(event.detail.variant.id);
    });
    
    const initialVariant = document.querySelector('input[name="id"], select[name="id"]')?.value;
    if (initialVariant) updateAllVariantMetafields(initialVariant);
  } else {
    // Single-Variant Produkt - zeige ALLE variant-info Elemente an
    const allVariantInfo = document.querySelectorAll('.variant-info');
    allVariantInfo.forEach(el => {
      el.style.display = 'flex';
    });
  }
});